
import ShopCard from "../../layouts/shop/components/cards/ShopCard";
import ShopPageTitle from "../../layouts/shop/components/pages/ShopPageTitle";
import ShopFormWrapper from "../../layouts/shop/components/forms/ShopFormWrapper";
import ShopTextInputElement from "../../layouts/shop/components/forms/inputs/ShopTextInputElement";
import ShopInputElement from "../../layouts/shop/components/forms/inputs/base/ShopInputElement";

export default {
  name: "AuthLoginByLinkRequest",
  components: { ShopInputElement, ShopTextInputElement, ShopFormWrapper, ShopPageTitle, ShopCard },
  auth: 'guest',
  data: () => ({
    email: ''
  }),
  methods: {
    async requestLoginLink(callback) {
      await this.$loginByLinkRepository.requestLoginLinkEmail(this.email)
        .then(() => {
        this.email = '';

        this.$modal.show({
          type: 'success',
          title: this.$t('login_by_link.request.success_title'),
          body: this.$t('login_by_link.request.success_message'),
          primary: {
            label: this.$t('common.confirm'),
            theme: 'primary',
            action: () => {},
          },
        });

          this.$router.push(
            this.localePath('/')
          );
      }).finally(() => callback());
    },
  },
}
